import { isProjectedPatchText, projectedPatchRounds } from './messagePresentation.js';
const firstTruthy = (...readers) => readers.reduce((result, read) => result || read(), undefined);
const everyTruthy = (...readers) => readers.reduce((result, read) => result && read(), true);const PATCH_APPLY_TERMINAL_STATUSES = new Set([
  'applied',
  'failed',
  'cancelled',
  'needs_confirmation',
]);
const NON_RENDERED_TIMELINE_TYPES = new Set([
  'workflow_projection',
]);

function isTerminalPatchApplyStatus(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return false;
  }
  return PATCH_APPLY_TERMINAL_STATUSES.has(String(value.status || '').trim());
}

export function selectRenderedTimelineItems({
  timelineItems,
} = {}) {
  if (!Array.isArray(timelineItems)) {
    return [];
  }
  const previewRounds = projectedPatchRounds(timelineItems);
  return timelineItems.flatMap((item, index) => {
    if (NON_RENDERED_TIMELINE_TYPES.has(String(firstTruthy(() => (Object(item).type), () => (''))).trim())) {
      return [];
    }
    const patchPreview = Object(Object(item).payload).patch_preview_result;
    const patchQuestionNode = Object(Object(item).payload).patch_question_node;
    const patchApplyStatus = Object(Object(item).payload).patch_apply_status;
    const derivedItems = isProjectedPatchText(item, previewRounds) ? [] : [item];
    const autoApplyPatch = Object(Object(patchPreview).apply).auto_apply === true;
    if (everyTruthy(() => (patchPreview), () => (typeof patchPreview === 'object'), () => (!Array.isArray(patchPreview)), () => (!autoApplyPatch))) {
      derivedItems.push({
        id: `patch-preview-${String(firstTruthy(() => (item.id), () => (index)))}`,
        type: 'patch_preview',
        payload: patchPreview,
        roundKey: String(firstTruthy(() => (item.roundKey), () => (''))).trim(),
      });
    }
    if (everyTruthy(() => (patchQuestionNode), () => (typeof patchQuestionNode === 'object'), () => (!Array.isArray(patchQuestionNode)))) {
      derivedItems.push({
        id: `patch-question-${String(firstTruthy(() => (item.id), () => (index)))}`,
        type: 'patch_question_node',
        payload: patchQuestionNode,
        roundKey: String(firstTruthy(() => (item.roundKey), () => (''))).trim(),
      });
    }
    if (isTerminalPatchApplyStatus(patchApplyStatus)) {
      derivedItems.push({
        id: `patch-apply-status-${String(firstTruthy(() => (item.id), () => (index)))}`,
        type: 'patch_apply_status',
        payload: patchApplyStatus,
        roundKey: String(firstTruthy(() => (item.roundKey), () => (''))).trim(),
      });
    }
    return derivedItems;
  });
}

export default selectRenderedTimelineItems;

/** Keep interaction components mounted so an explicit failure can restore their inputs. */
export const projectPatchQuestionPresentations = (timelineItems, presentations, scopeKey) => timelineItems.map((item) => {
  if (item.type !== 'patch_question_node') return item;
  const interactionKey = JSON.stringify([scopeKey, item.id, item.payload?.node_id]);
  return { ...item, interactionKey,
    presentation: presentations.get(interactionKey) ?? { interactive: true, pending: false, errorMessage: '' } };
});
